import { call, put, select, takeEvery } from 'redux-saga/effects';
import request from 'helpers/api';
import ImagePreloader from 'image-preloader';

import { getCurrentDesign, getDesigns } from 'redux/selectors/design';

import { add } from 'redux/reducers/designs';
import { SET_ACTIVE_ORDER } from 'redux/reducers/app';
import { SET_OPTION } from 'redux/reducers/orders';

export function* getDesignOnChange({ option }) {
  try {
    if (option === 'design') {
      yield getDesign({});
    }
  } catch (e) {
    pe(e, 'failed getDesignOnChange');
  }
}

/**
 * Get design if not available
 */
export function* getDesign({ designId }) {
  try {
    designId = designId ? designId : yield select(state => getCurrentDesign(state));
    const design = yield select(state => getDesigns(state).find(design => design.get('id') === designId));

    if (designId && !design) {
      const newDesign = yield call(request, 'designs/get/' + designId);
      yield put(add(newDesign));

      // Preload images
      setTimeout(() => {
        const images = [];
        Object.keys(newDesign.spreads).forEach(key => {
          newDesign.spreads[key].graphics.forEach(graphic => {
            if (images.indexOf(graphic.image) === -1) {
              images.push(graphic.image);
            }
          });
          newDesign.spreads[key].moments.forEach(moment => {
            try {
              const url = moment.options.placeholder_image.url;
              if (images.indexOf(url) === -1) {
                images.push(url);
              }
            } catch (e) {}
          });
        });

        const preloader = new ImagePreloader();
        preloader.preload(...images).then(() => {
          p('Preloaded design images!');
        });
      }, 2000);
    }
  } catch (e) {
    pe(e, 'failed getDesign');
  }
}

export default function* saga() {
  yield takeEvery(SET_OPTION, getDesignOnChange);
  yield takeEvery(SET_ACTIVE_ORDER, getDesign);
}



// WEBPACK FOOTER //
// ./app/redux/sagas/design.js